<template>
  <div></div>
</template>
<script>
import { getUserInfo } from "@/api/user";
import { getIsAccessIndustry } from "@/api/industry";

export default {
  name: "",
  data() {
    return {};
  },
  created() {
    let token = this.$route.query.token;
    if (token) {
      _Cookie.set("adminauth", token);
      this.getUserInfo();
      this.$Message.success("登录成功");
    } else {
      this.$router.push({ path: localStorage.LOGIN_URL });
    }
  },
  methods: {
    getUserInfo() {
      let self = this;
      getUserInfo().then(async (res) => {
        let userInfo = res.data.data;
        userInfo.loginAccount = userInfo.account
          ? userInfo.account
          : userInfo.mobilePhone
          ? userInfo.mobilePhone
          : userInfo.email
          ? userInfo.email
          : "";
        localStorage.setItem("USER_NAME", userInfo.loginAccount);
        localStorage.setItem("USER_ROLE", userInfo.accountType);
        let auth = userInfo.id == 10000 ? true : false;
        localStorage.setItem("USER_AUTH", auth);
        localStorage.setItem("USER_ID", userInfo.id);
        localStorage.setItem("adminAvatar", userInfo.avatarUrl);
        this.$store.commit("setUserImg", userInfo.avatarUrl);
        this.$store.commit("setUsername", userInfo.loginAccount);
        await this.getIsAccessIndustryVersion();
        async function getRole() {
          try {
            const role = await self.$store.dispatch("getRole");
            console.log(role, "role--");
            if (!role) {
              self.$router.push({ path: "/no-auth" });
              return;
            }
            let list = role.menuList;
            console.log(list, "rolepage");
            self.$router.push({ path: list[0].path });
          } catch {
            console.log("获取权限列表失败");
          }
        }
        getRole();
      });
    },
    getIsAccessIndustryVersion() {
      return getIsAccessIndustry().then((res) => {
        console.log(res, "是否介入了工业互联网--permission");
        if (res.data && res.data.data == true) {
          localStorage.setItem("IS_ACCESS_INDUSTRY", 1);
        } else {
          localStorage.setItem("IS_ACCESS_INDUSTRY", 0);
        }
      });
    },
  },
};
</script>
<style lang="scss">
</style>